<script>
    import 'firebase/auth';
    import { getContext } from 'svelte';

    const auth = getContext('firebase').getFirebase().auth();

    let email = '';
    let password = '';

    let errorMessage = '';
    $: disabled = !email || !password;

    function login() {
        if (disabled) {
            return;
        }
        auth.signInWithEmailAndPassword(email, password).catch((err) => {
            errorMessage = err.message;
        });
	}
</script>

<div class="form-wrapper">
    <form on:submit|preventDefault={login}>
        <input bind:value={email} type="text" placeholder="Email">
        <input bind:value={password} type="password" placeholder="Password">
        <input type="submit" value="Login" disabled={disabled}>
    </form>
    {#if errorMessage}
        <div class="form-error-message">
            <span>{errorMessage}</span>
        </div>
    {/if}
</div>
<div class="links">
    <a class="grey-a" href="/?p=forgot-password">Forgot password</a>
</div>

<style>
    input[type=text], input[type=password] {
        width: 100%;
    }

    input[type=password] {
        margin: 10px 0px;
    }

    input[type=submit] {
        margin-top: 10px;
    }

    input[type=submit]:hover {
        cursor: pointer;
    }

    input[type=submit]:disabled {
        background-color: var(--grey);
    }

    .links {
        width: 100%;
        text-align: center;
        margin-top: 20px;
    }

    a {
        display: block;
        margin: 10px;
    }
</style>
